import React, {Component} from 'react';
import './Cours.css';

class Article extends Component {

    render() {
        return (

            <div id="cours" className="row home-block">

                <div>
                    <h2 className="title">Cours</h2>
					<p> Most of my teaching materials are made available on the university’s or school’s Moodle learning platform.
Here are, however, a few documents, lecture notes, exercises, assignments, and other materials from my teaching years here :
					</p>

					<ul>
						<li> <a href="https://drive.google.com/file/d/1i9dQYKvK4Pk0l1Nw57o9I_aCdf-Q62PE/view?usp=sharing">Cours Intro AI (Université de Toulouse, 2025-2026)</a> </li>
						<li> <a href="https://drive.google.com/file/d/1_fMRWVOD5tNWM7AsBgEae2y4i4tI4Gjn/view?usp=sharing">Cours Intro au RL (Université de Toulouse, 2025-2026) </a>  </li>
						<li> <a href="https://drive.google.com/file/d/1LSa_1nta-F156erTdaDVDHUsIcuWnt1Q/view?usp=sharing">Cours Intro au Deep Learning part1 (Université de Toulouse, 2025-2026) </a> </li>
						<li> <a href="https://colab.research.google.com/drive/15W7LrP7f2uTH8pRRp-hA6Gors3EDuHvO?usp=sharing">Cours Intro au Deep Learning part2 (Université de Toulouse, 2025-2026) </a> </li>
						<li> <a href="https://drive.google.com/file/d/1I2_GbpTHZ1kS4CNCsomuJOfvVAf3Fi6P/view?usp=sharing">Cours Science des données (Université de Toulouse, 2023-2024) </a> </li>
						<li><a href="/cours-estimation-2019">Estimation - Analyse de données, M1 E.S.I.E.A. 2019-2020 </a> </li>
						<li> <a href="/cours-estimation-2018">Estimation - Analyse de données, M1 E.S.I.E.A. 2018-2020</a> </li>
						<li> <a href="/cours-analyse-exploratoire-2018">Analyse exploratoire, M2 E.S.I.E.A. 2018-2020</a> </li>
						<li> <a href="/cours-modeles-pour-la-datascience-2018">Modèles pour la data science, M2 E.S.I.E.A. 2018-2020 </a>  </li>
						<li> <a href="/cours-base-de-donnees-2019">Base de données, M1 Statistiques, Univ. de Strasbourg 2018-2019</a> </li>
					</ul>
                </div>
            </div>
        );
    }
}

export default Article;



// WEBPACK FOOTER //
// ./src/Components/Cours/Cours.js